import { formatClockText } from '../../../../../../platform/util/clockSystem';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { format } from 'date-fns';
import { calendarMonthRange, formatCalendarDate } from '../../../../../../platform/util/calendarSystem';

// Function to group events by date
const groupEventsByDate = (events) => {
    return events.reduce((acc, event) => {
        const eventDate = format(new Date(event.time), 'yyyy-MM-dd');
        if (!acc[eventDate]) {
            acc[eventDate] = [];
        }
        acc[eventDate].push(event);
        return acc;
    }, {});
};

const RenderEventListForMonth = (month, events, calendar = 'gregory', clock = 'standard') => {
    const range = calendarMonthRange(format(month, 'yyyy-MM-dd'), calendar);
    const startDate = range.start;
    const endDate = range.end;

    // Filter events for the selected month
    const monthEvents = events.filter(event => {
        const eventDate = format(new Date(event.time), 'yyyy-MM-dd');
        return eventDate >= startDate && eventDate <= endDate;
    });

    // Group the filtered events by date
    const groupedEvents = groupEventsByDate(monthEvents);

    // Split the grouped events into left and right columns
    const eventDates = Object.keys(groupedEvents);
    const leftColumnDates = eventDates.slice(0, Math.ceil(eventDates.length / 2));
    const rightColumnDates = eventDates.slice(Math.ceil(eventDates.length / 2));

    const renderColumn = (dates) => (
        <Box>
            {dates.map((date, index) => (
                <Box key={index} mb={2}>
                    {/* Date heading */}
                    <Typography variant="subtitle1" gutterBottom align="left">
                        {formatCalendarDate(date, calendar)}
                    </Typography>
                    {/* Event details under each date */}
                    {groupedEvents[date].map((event, eventIndex) => (
                        <Typography
                            key={eventIndex}
                            variant="caption"
                            style={{ display: 'block', paddingLeft: '16px', textAlign: 'left' }}
                        >
                            {formatClockText(format(new Date(event.time), 'hh:mm a'), clock)} - {event.inviteeName}
                        </Typography>
                    ))}
                </Box>
            ))}
        </Box>
    );

    return (
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
            {/* Left column */}
            <Box flex="1" pr={2}>
                {renderColumn(leftColumnDates)}
            </Box>
            {/* Right column */}
            <Box flex="1" pl={2}>
                {renderColumn(rightColumnDates)}
            </Box>
        </Box>
    );
};

export default RenderEventListForMonth;